module.exports = __webpack_public_path__ + "img/jingzi.eaee0ada.png";